import { newGatewayUrl } from '@/constant';
import request from '@hb/sharp-request';

// 邀请好友活动
export const getParticipants = (actCode: string): Promise<InvitePO> => request.postGate('f.activity.invite.participants',
  { actCode },
  {
    baseURL: newGatewayUrl,
  });

const SHareApi = {
  getParticipants,
};

export default SHareApi;
